import { forwardRef } from "react";

import type { PictureWrapperProps } from "./PictureBehaviourContext";
import { usePicture } from "./PictureBehaviourContext";

export type PictureBehaviourProps = PictureWrapperProps & {
  nativeBehaviour?: boolean;
};

export const PictureBehaviour = forwardRef<HTMLImageElement, PictureBehaviourProps>(
  ({ nativeBehaviour, ...props }, ref) => {
    const PictureComponent = usePicture();

    if (nativeBehaviour || !PictureComponent) {
      const { alt, ...imageProps } = props.imageProps;

      return (
        <picture className={props.className}>
          {props.sources.map(({ srcSet, media, type }, index) => (
            <source key={`${srcSet}_${index}`} srcSet={srcSet} media={media} type={type} />
          ))}
          <img alt={alt} {...imageProps} ref={ref} />
        </picture>
      );
    }

    const connectedProps = { ...props, imageProps: { ...props.imageProps, ref } };

    return <PictureComponent {...connectedProps} />;
  }
);

PictureBehaviour.displayName = "PictureBehaviour";
